const styles = (theme) => ({
  root: {
    backgroundColor: 'white',
    width: '100%',
    padding: '30px 30px 30px 30px',
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginRight: 30,
  },
  divider: {
    margin: '30px 0px'
  }
});

export default styles;
